import React, { useEffect, useRef, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faIdBadge, faRightFromBracket, faSliders, faPlus, faBars, } from '@fortawesome/free-solid-svg-icons';
import { NavItems } from './NavItems';
import { Modal } from './Modal';
import { CreateKreeda } from '../CreateWizard/CreateKreeda';
// interface SearchResult {
//   id: string;
//   name: string;
//   type: 'quiz' | 'crossword';
//   url: string;
// }
export const Header = ({ auth }) => {
    const quizzes = useSelector((state) => state.quizState.quizzes);
    const crosswords = useSelector((state) => state.crosswordState.crosswords);
    const location = useLocation();
    const refAccount = useRef(null);
    const refNav = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    // const [searchTerm, setSearchTerm] = useState('');
    // const [searchResults, setSearchResults] = useState<SearchResult[]>([]);
    // const [showResults, setShowResults] = useState(false);
    const handleModalOpen = (event) => {
        event.preventDefault();
        setIsModalOpen(true);
    };
    const handleModalClose = () => {
        setIsModalOpen(false);
    };
    const closeOpenMenus = (e) => {
        if (e) {
            if (isOpen && !refAccount.current?.contains(e.target)) {
                setIsOpen(false);
            }
            const menuToggle = document.getElementById('menu');
            if (menuToggle &&
                menuToggle.checked &&
                !refNav.current?.contains(e.target)) {
                menuToggle.checked = false;
            }
            else if (refNav.current?.contains(e.target) &&
                e.target.className.includes('nav-pane__link')) {
                menuToggle.checked = false;
            }
        }
        else {
            if (isOpen) {
                setIsOpen(false);
            }
        }
    };
    // const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    //   const term = e.target.value.toLowerCase();
    //   setSearchTerm(term);
    //   if (term.trim() === '') {
    //     setSearchResults([]);
    //     setShowResults(false);
    //     return;
    //   }
    //   const matchingQuizzes = quizzes
    //     .filter((quiz) => quiz.name.toLowerCase().includes(term))
    //     .map((quiz) => ({
    //       id: quiz.quizId,
    //       name: quiz.name,
    //       type: 'quiz' as const,
    //       url: `/quizzes/${quiz.quizId}`,
    //     }));
    //   const matchingCrosswords = crosswords
    //     .filter((crossword) => crossword.name.toLowerCase().includes(term))
    //     .map((crossword) => ({
    //       id: crossword.crosswordId,
    //       name: crossword.name,
    //       type: 'crossword' as const,
    //       url: `/crosswords/${crossword.crosswordId}`,
    //     }));
    //   setSearchResults([...matchingQuizzes, ...matchingCrosswords]);
    //   setShowResults(true);
    // };
    // const handleBlur = () => {
    //   // Small delay to allow click on search result
    //   setTimeout(() => {
    //     setShowResults(false);
    //   }, 200);
    // };
    useEffect(() => {
        closeOpenMenus();
    }, [location]);
    document.addEventListener('mousedown', closeOpenMenus);
    return (React.createElement("div", { className: "header" },
        React.createElement("div", { className: "mobile-nav" },
            React.createElement("input", { className: "menu-toggle", id: "menu", type: "checkbox", defaultChecked: false }),
            React.createElement("label", { htmlFor: "menu", className: "menu-container" },
                React.createElement(FontAwesomeIcon, { icon: faBars, className: "menu-button" })),
            React.createElement("div", { className: "mobile-nav-pane", ref: refNav },
                React.createElement("button", { onClick: () => {
                        const menuElement = document.getElementById('menu');
                        if (menuElement) {
                            menuElement.checked = false;
                        }
                    } }, "X"),
                React.createElement(NavItems, null)),
            React.createElement(Link, { className: "root-link", to: "/" },
                React.createElement("div", { className: "logo-g" }, "G"),
                "\u00A0",
                React.createElement("div", { className: "logo-k" }, "K"),
                React.createElement("div", { className: "logo-gyaan" }, "GYAAN"),
                "\u00A0",
                React.createElement("div", { className: "logo-kreeda" }, "KREEDA"))),
        React.createElement("div", { className: "header-rest" },
            React.createElement("button", { className: "btn--primary web", onClick: handleModalOpen, title: "Create a new quiz, crossword, or survey" },
                React.createElement(FontAwesomeIcon, { icon: faPlus }),
                React.createElement("span", null, "Create")),
            React.createElement("button", { className: "btn--primary mobile", onClick: handleModalOpen, title: "Create new" },
                React.createElement(FontAwesomeIcon, { icon: faPlus })),
            React.createElement(Modal, { id: "create-kreeda", component: CreateKreeda, componentProps: {}, isOpen: isModalOpen, onClose: handleModalClose }),
            React.createElement("div", { className: "header__account-section", ref: refAccount },
                React.createElement("button", { onClick: () => setIsOpen(!isOpen), className: "btn--secondary mobile" }, auth.name
                    ? auth.name
                        .split(' ')
                        .map((n) => n[0])
                        .join('')
                    : 'U'),
                React.createElement("button", { onClick: () => setIsOpen(!isOpen), className: "btn--secondary web" }, auth.name || 'User'),
                React.createElement("div", { className: `dropdown-menu ${isOpen ? 'show' : ''}` },
                    React.createElement(Link, { to: "/profile" },
                        React.createElement(FontAwesomeIcon, { icon: faIdBadge }),
                        "Profile"),
                    React.createElement(Link, { to: "/settings" },
                        React.createElement(FontAwesomeIcon, { icon: faSliders }),
                        "Settings"),
                    React.createElement("button", { onClick: () => auth.logout && auth.logout() },
                        React.createElement(FontAwesomeIcon, { icon: faRightFromBracket }),
                        "Logout"))))));
};
